import {
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  computed,
  inject,
  input,
  output,
} from '@angular/core';
import { MatIcon } from '@angular/material/icon';

@Component({
  selector: 'eventq-site-stat-flag',
  imports: [MatIcon],
  templateUrl: './site-stat-flag.html',
  styleUrl: './site-stat-flag.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    role: 'button',
    tabindex: '0',
    '[attr.aria-label]': 'ariaLabel()',
    '(click)': 'onPressed()',
    '(keydown.enter)': 'onPressed()',
    '(keydown.space)': 'onPressed($event)',
  },
})
export class EventqSiteStatFlag {
  private readonly host = inject(ElementRef<HTMLElement>);

  /** Host element for anchored overlays such as dialog popovers. */
  readonly hostElement = this.host.nativeElement;

  readonly armed = input.required<boolean>();
  readonly count = input.required<number>();
  readonly label = input<string>();

  readonly pressed = output<void>();

  readonly displayLabel = computed(() => {
    const custom = this.label();
    if (custom) {
      return custom;
    }
    return this.armed() ? 'Armed Sites' : 'Disarmed Sites';
  });

  readonly ariaLabel = computed(() => `${this.displayLabel()}, ${this.formattedCount()}`);

  readonly formattedCount = computed(() =>
    new Intl.NumberFormat('en-US').format(this.count()),
  );

  onPressed(event?: Event): void {
    if (event instanceof KeyboardEvent) {
      event.preventDefault();
    }
    this.pressed.emit();
  }
}
